import {
    ChangeDetectionStrategy,
    Component,
    input,
} from '@angular/core';

@Component({
    selector: 'bd-message-empty',
    template: `
    <div class="message__empty">
      <div class="flex flex-row gap-2 items-center justify-center">
        <div class="flex-none">
          <i class="message__empty-icon {{ icon() }}" aria-hidden="true"></i>
        </div>
        <div class="flex-none">
          <small class="message__empty-text">{{ message() }}</small>
        </div>
      </div>
    </div>
  `,
    styles: [
        `
      .message__empty {
        color: var(--p-text-muted-color);
      }

      .message__empty-icon {
        font-size: 1.5rem;
        vertical-align: middle;
      }

      .message__empty-text {
        line-height: 28px;
      }
    `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BdMessageEmptyComponent {
    /** PrimeIcons class, e.g. `pi pi-times-circle` (see icons.md). */
    icon = input('pi pi-eye-slash');
    message = input('');
}
